import React, { Component } from 'react';
import '../../css/Footer.css';

export default class Footer extends Component {

  constructor(props) {
      super(props);
      this.state = {
      }
  }

  getHTML = (text) => {

  var str =  {__html: text};

  return str;

  }

  render() {

    return (


      <div className="footer" >


          <div  dangerouslySetInnerHTML={this.getHTML(this.props.datas[0].texte_html)} />

      </div>
    );
  }

}
